module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmh"
  }, [_vm._v("NOVELS BY K. C. CONSTANTINE")]), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("GRIEVANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("BLOOD MUD")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("BRUSHBACK")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("FAMILY VALUES")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("GOOD SONS")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("CRANKS AND SHADOWS")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("BOTTOM LINER BLUES")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("SUNSHINE ENEMIES")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("JOEY’S CASE UPON SOME MIDNIGHTS CLEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("ALWAYS A BODY TO TRADE")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("THE MAN WHO LIKED SLOW TOMATOES")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("A FIX LIKE THIS")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("THE BLANK PAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("THE MAN WHO LIKED TO LOOK AT HIMSELF")])]), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('em', [_vm._v("THE ROCKSBURG RAILROAD MURDERS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f75534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SavingRoomForD_blur-1.vue
// module id = 66
// module chunks = 0